import React, { Component } from "react";

export default class ProjectInfo extends Component {
  	
	render () {
		
		let post = this.props.block;
	
		if (post) {
						
		    return (
			    
			    <div className="c-project__info c-page__block--load-effect">	
			    						
					<div className="c-project__info__inner">
						
						<div className="c-project__info__inner__left">						
							<div className="scope-text scope-text--dark" dangerouslySetInnerHTML={ {__html:post.info}}></div>
						</div>
						<div className="c-project__info__inner__right">
							<div className="scope-text scope-text--dark" dangerouslySetInnerHTML={ {__html:post.credits}}></div>
						</div>
															
					</div>
									    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
